export function TranslateOrderStatus(stage) {

    var a = {value:0, label:""};

    switch(stage) {
        case "draft":
            a = {value:0, label:"Entwurf"};
            break;
        case "inTender":
            a = {value:20, label:"In Angebotsphase"};
            break;
        case "contracted":
            a = {value:40, label:"Beauftragt"};
            break;
        case "inDevelopment":
            a = {value:60, label:"In Bearbeitung"};
            break;
        case "inReview":
            a = {value:80, label:"Zur Abnahme"};
            break;
        case "completed":
            a = {value:100, label:"Abgeschlossen"};
            break;
        default:
           a = {value:0, label:""};
    }

    return a;
}

